import { createGranularRequestConfig } from "@granular/fabric-catalog-helpers";
import axios, { AxiosResponse } from "axios";
import { RefreshTokens, AuthSuccessSpec, FetchTokens } from "./schemas";

/**
 * Exchange a refresh token for fresh ID, Access, and Refresh Tokens
 *
 * @param token Refresh token
 * @returns An `AuthSuccessSpec` object
 */
export const refreshTokens = async ({
  token,
  authRequestConfig,
  axiosRequestConfig,
  domain = "",
}: RefreshTokens): Promise<AxiosResponse<AuthSuccessSpec>> => {
  const response = await axios.post(
    `${domain}/api/auth-svc/refresh_legacy`,
    { token },
    createGranularRequestConfig(authRequestConfig, { axiosRequestConfig }),
  );
  return response;
};

/**
 * Exchange a session code for ID, Access, and Refresh Tokens
 *
 * @param code Session code
 * @returns An `AuthSuccessSpec` object
 */
export const fetchTokens = async ({
  code,
  authRequestConfig,
  axiosRequestConfig,
  domain = "",
}: FetchTokens): Promise<AxiosResponse<AuthSuccessSpec>> => {
  const response = await axios.get(
    `${domain}/api/auth-svc/issue-token?code=${code}`,
    createGranularRequestConfig(authRequestConfig, { axiosRequestConfig }),
  );
  return response;
};

export default {
  refreshTokens,
  fetchTokens,
};
